module.exports = __webpack_public_path__ + "img/home-app-image-hk.2f1fa62e.png";